export { ScrollToOptions, scrollTo } from './scroll-to';
